import triggerTracking from '@blueprint/tracking';
import { ListingAnalyticsTaxonomy } from 'graphql.generated';
import { TRACKING_EVENT, TRACKING_CATEGORY } from 'listing-details/constants';
import {
    getListingSectionFromString,
    getDetailsTrackingPageFromSection
} from 'listing-details/helpers';
import { trackEvent } from 'shared/helpers/segment/trackEvent';
import { BaseTaxonomy, EventNames } from 'shared/tracking/contracts';

type SegmentTrackingProps = {
    listingId: number;
    taxonomy: Pick<ListingAnalyticsTaxonomy, 'section' | 'brandName'>;
};

export const trackTopAgentImage = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'clickthrough',
        eventLabel: 'Agent block 1'
    });
};

export const trackViewAgentPropertiesLink = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'clickthrough',
        eventLabel: 'Agent properties link'
    });
};

export const trackEmailAgentCTA = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click',
        eventLabel: 'email main btn'
    });
};

export const trackCallAgentCTA = (trackingData: SegmentTrackingProps) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'call',
        eventLabel: 'call main btn'
    });
    trackCallAgentSegmentEvent(trackingData);
};

export const trackCallAgentCTADesktop = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'call',
        eventLabel: 'Agent phone number 1'
    });
};

export const trackCallAgentSplitTest = (variant: 'original' | 'variant') => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'optimizely',
        eventAction: 'lex-595-call-agent-click',
        eventLabel: variant
    });
};

export const trackCallAgentVariantReveal = (
    trackingData: SegmentTrackingProps
) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click',
        eventLabel: 'reveal agent number'
    });
    trackCallAgentSegmentEvent(trackingData);
};

const trackCallAgentSegmentEvent = ({
    listingId,
    taxonomy: { brandName, section }
}: SegmentTrackingProps) => {
    trackEvent(EventNames.CLICK_CALL_AGENT, {
        brand: brandName,
        page: getDetailsTrackingPageFromSection(
            getListingSectionFromString(section)
        ),
        section: getListingSectionFromString(
            section
        ) as BaseTaxonomy['section'],
        pagePosition: 'top',
        listingId: listingId.toString()
    });
};
